import createReducer from '../utils/createReducer';
import actions from './actions';
import merge from 'lodash.merge';

const initialState = {};

function indexByListingId(listings) {
    return listings.reduce((obj, listing) => {
        obj[listing.listingId] = listing;
        return obj;
    }, {});
}

function indexByBoardId(boards) {
    return boards.reduce((obj, board) => {
        obj[board.boardId] = board;
        return obj;
    }, {});
}

function flattenPreview({tripBoard, previews}) {
    const listingsById = indexByListingId(tripBoard.listings);
    const previewsById = indexByListingId(previews);
    const listings = merge({}, previewsById, listingsById);
    return {
        ...tripBoard,
        listings
    };
}

function flattenDetail({tripBoard, views}) {
    const listingsById = indexByListingId(tripBoard.listings);
    const flattenedViews = views.map(({hit, presentation, listingId}) => {
        return {
            ...hit,
            ...presentation,
            listingId
        };
    });
    const viewsById = indexByListingId(flattenedViews);
    const listings = merge({}, viewsById, listingsById);
    tripBoard.endDate = tripBoard.endDate || null;
    tripBoard.startDate = tripBoard.startDate || null;
    return {
        ...tripBoard,
        listings
    };
}

const actionHandlers = {};

actionHandlers[actions.FETCH_PREVIEWS_SUCCESS] = (state, {payload}) => {
    const flattened = payload.apiData.map(flattenPreview);
    return merge({}, state, indexByBoardId(flattened));
};

actionHandlers[actions.FETCH_DETAILS_SUCCESS] = (state, {payload}) => {
    const boardToMerge = indexByBoardId([flattenDetail(payload.apiData)]);
    return merge({}, state, boardToMerge);
};

actionHandlers[actions.DELETE_TRIPBOARD_START] = (state, {payload}) => {
    const newState = {...state};
    delete newState[payload.boardId];
    return newState;
};

actionHandlers[actions.DELETE_TRIPBOARD_LISTING_START] = (state, {payload}) => {
    const {boardId, listingId} = payload;
    const board = state[boardId];
    if (!board) {
        return state;
    }
    const newListings = {...board.listings};
    delete newListings[listingId];
    const newBoard = {
        ...board,
        listings: newListings
    };
    const newState = {...state};
    newState[boardId] = newBoard;
    return newState;
};

actionHandlers[actions.RENAME_TRIPBOARD_START] = (state, {payload}) => {
    const {boardId, name} = payload;
    const board = state[boardId];
    if (!board) {
        return state;
    }
    const newBoard = {
        ...board,
        name
    };
    const newState = {...state};
    newState[boardId] = newBoard;
    return newState;
};

export default createReducer(actionHandlers, initialState);



// WEBPACK FOOTER //
// ./src/universal/tripboard/tripboard-reducer.js